import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import UndoIcon from '@mui/icons-material/Undo';

import {
    NomalButton,
    CautionButton,
    GrayButton
} from '../css/CSS.js';


export default function InspectionCommonDialog({ dialogState }) {
    const handleClose = () => {

        if (dialogState.cancelClick) {
            dialogState.cancelClick();
        }
    };

    const handleOpen = () => {
        if (dialogState.confirmClick) {
            dialogState.confirmClick();
        }
    };
    const BUTTON_MAP = {
        NomalButton,
        CautionButton,
        GrayButton
    };
    const ButtonComponent =
        BUTTON_MAP[dialogState?.buttonType] ?? CautionButton;

    return (
        <Dialog
            open={dialogState.open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title"
                sx={{
                    fontSize: '2rem',
                    color: '#ffffff',
                    py: 3,
                    backgroundColor: "#1976d2",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                {dialogState?.title}
            </DialogTitle>
            <DialogContent>
                <Typography sx={{ fontSize: '1.5rem', p: 3, whiteSpace: "pre-line" }}>
                    {dialogState?.message}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Grid container
                    sx={{
                        justifyContent: dialogState?.hideCancel ? "flex-end" : "space-between",
                        alignItems: "center",
                        mb: 2
                    }}>
                    {!dialogState?.hideCancel && (
                        <GrayButton variant="contained" size="large" onClick={handleClose}
                            sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                            <UndoIcon sx={{ mr: 2, fontSize: '2rem' }} />
                            {dialogState?.cancel ?? "いいえ"}
                        </GrayButton>
                    )}
                    <ButtonComponent variant="contained" size="large" onClick={handleOpen}
                        sx={{
                            ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem'
                            , "& .MuiButton-startIcon": {
                                mr: 2
                            },
                            "& .MuiButton-startIcon svg": {
                                fontSize: "2rem"
                            }
                        }}
                        startIcon={dialogState?.confirmIcon ?? <DeleteForeverIcon />}
                    >
                        {dialogState?.confirm ?? "はい"}
                    </ButtonComponent>
                </Grid>
            </DialogActions>
        </Dialog>)
}